export default (htmlString: string): string => {
  return htmlString.replace(
    /&lt;!--\[if[\s\S]*?\]&gt;|&lt;!\[if[\s\S]*?\]&gt;|&lt;!\[endif\]--&gt;|&lt;!\[endif\]&gt;|&lt;!--[\s\S]*?--&gt;/g,
    (match) => {
      return match.replace(/&lt;!/g, "<!").replace(/&gt;/g, ">");
    }
  );
};
